import ConfirmModal from '@/common/containers/Modals/ConfirmModal/ConfirmModal';

export default ConfirmModal;
